function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { cx } from "../../helpers/utils/cx";
const DEFAULT_PADDING = 5;
const elevationStyles = {
  "floor-1": "bg-layer-floor-1 border-solid border border-neutral-secondary",
  "floor-2": "bg-layer-floor-2 shadow-md",
  "floor-3": "bg-layer-floor-3 shadow-lg",
  surface: "bg-layer-surface",
  outlined: "bg-special-nulled border-solid border border-separator"
};
const cornerStyles = {
  rounded: "rounded-lg",
  square: "rounded-none"
};
export function Island(_ref) {
  let {
    elevation = "floor-1",
    corners = "rounded",
    children,
    padding = DEFAULT_PADDING,
    paddingTop,
    paddingLeft,
    paddingBottom,
    paddingRight,
    className
  } = _ref;
  const containerStyle = React.useMemo(() => {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, padding !== undefined && {
      padding: getRemFromSpacingSize(padding)
    }), paddingTop !== undefined && {
      paddingTop: getRemFromSpacingSize(paddingTop)
    }), paddingLeft !== undefined && {
      paddingLeft: getRemFromSpacingSize(paddingLeft)
    }), paddingRight !== undefined && {
      paddingRight: getRemFromSpacingSize(paddingRight)
    }), paddingBottom !== undefined && {
      paddingBottom: getRemFromSpacingSize(paddingBottom)
    });
  }, [padding, paddingLeft, paddingTop, paddingRight, paddingBottom]);
  return /*#__PURE__*/React.createElement("div", {
    style: containerStyle,
    className: cx(elevationStyles[elevation], cornerStyles[corners], className)
  }, children);
}
function getRemFromSpacingSize(spacingValue) {
  return `${spacingValue / 4}rem`;
}